import jsPDF from "jspdf";
import html2canvas from "html2canvas";

const COMPANY = {
  name: "G.M. AGENCIES",
  address1: "597 Muhamadia Nagar, Dharapuram - 638656",
  address2: "Tiruppur Dist.",
  phone: "8610697070",
  gstin: "33GLSPS9037Q1ZT",
  fssai: "12425027000427",
  tagline: "GM Kridam Foods · Distribution",
  gpay: "9488020172",
};

const fmtINR = (n) =>
  new Intl.NumberFormat("en-IN", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(Number(n) || 0);

const fmtDate = (iso) => {
  if (!iso) return "";
  const d = new Date(iso);
  const dd = String(d.getDate()).padStart(2, "0");
  const mm = String(d.getMonth() + 1).padStart(2, "0");
  const yy = String(d.getFullYear());
  return `${dd}/${mm}/${yy}`;
};

const numToWordsIndian = (num) => {
  num = Math.floor(Number(num) || 0);
  if (num === 0) return "Zero Rupees Only";
  const a = [
    "", "One", "Two", "Three", "Four", "Five", "Six", "Seven", "Eight", "Nine",
    "Ten", "Eleven", "Twelve", "Thirteen", "Fourteen", "Fifteen", "Sixteen",
    "Seventeen", "Eighteen", "Nineteen",
  ];
  const b = [
    "", "", "Twenty", "Thirty", "Forty", "Fifty", "Sixty", "Seventy", "Eighty", "Ninety",
  ];
  const two = (n) =>
    n < 20 ? a[n] : `${b[Math.floor(n / 10)]}${n % 10 ? " " + a[n % 10] : ""}`;
  const three = (n) => {
    const h = Math.floor(n / 100);
    const r = n % 100;
    return `${h ? a[h] + " Hundred" + (r ? " " : "") : ""}${r ? two(r) : ""}`;
  };
  let out = "";
  const crore = Math.floor(num / 10000000); num %= 10000000;
  const lakh = Math.floor(num / 100000); num %= 100000;
  const thousand = Math.floor(num / 1000); num %= 1000;
  if (crore) out += two(crore) + " Crore ";
  if (lakh) out += two(lakh) + " Lakh ";
  if (thousand) out += two(thousand) + " Thousand ";
  if (num) out += three(num);
  return out.trim().replace(/\s+/g, " ") + " Rupees Only";
};

const esc = (s) =>
  String(s == null ? "" : s)
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;");

function buildInvoiceHtml(order, store) {
  const cashCredit = order.payment_status === "paid" ? "CASH" : "CREDIT";
  const rows = (order.items || [])
    .map(
      (it, i) => `
        <tr>
          <td class="c">${i + 1}</td>
          <td class="l">${esc(it.product_name)}</td>
          <td class="c">${it.quantity}</td>
          <td class="r">${fmtINR(it.unit_price)}</td>
          <td class="r">${fmtINR(it.line_total)}</td>
        </tr>`,
    )
    .join("");

  return `
  <div id="__invoice_root" style="
      width: 794px;
      padding: 32px;
      background: #fff;
      color: #111;
      font-family: 'Noto Sans Tamil', 'Latha', 'Nirmala UI', 'Arial Unicode MS', system-ui, -apple-system, Segoe UI, Roboto, Arial, sans-serif;
      box-sizing: border-box;
    ">
    <style>
      #__invoice_root * { box-sizing: border-box; }
      #__invoice_root h1 {
        margin: 0; font-size: 30px; letter-spacing: 1px; text-align: center; font-weight: 800;
      }
      #__invoice_root .tag { text-align: center; font-size: 12px; color: #444; margin-top: 4px; }
      #__invoice_root .rule { border-top: 1px solid #111; margin: 14px 0 8px; }
      #__invoice_root .titleRow {
        display:flex; justify-content:space-between; align-items:center;
        font-size: 13px; margin-bottom: 14px;
      }
      #__invoice_root .titleRow .mid { font-size: 15px; font-weight: 700; letter-spacing: 1px; }
      #__invoice_root .grid {
        display:flex; justify-content:space-between; gap: 18px; margin-bottom: 14px;
      }
      #__invoice_root .grid .col { font-size: 13px; line-height: 1.5; }
      #__invoice_root .grid .col b { font-weight: 700; }
      #__invoice_root table.items {
        width: 100%; border-collapse: collapse; font-size: 13px; margin-top: 6px;
      }
      #__invoice_root table.items th, #__invoice_root table.items td {
        border: 1px solid #222; padding: 7px 8px;
      }
      #__invoice_root table.items th {
        background: #111; color: #fff; font-weight: 700; text-align: center;
      }
      #__invoice_root .c { text-align: center; }
      #__invoice_root .l { text-align: left; }
      #__invoice_root .r { text-align: right; font-variant-numeric: tabular-nums; }
      #__invoice_root .totalRow {
        display:flex; justify-content:flex-end; gap: 18px;
        font-weight: 800; font-size: 16px; padding: 10px 8px;
        border-top: 2px solid #111; margin-top: 6px;
      }
      #__invoice_root .totalRow .lbl { color:#444; font-weight: 700; }
      #__invoice_root .words { font-size: 12px; font-style: italic; margin-top: 4px; }
      #__invoice_root .notes { font-size: 12px; margin-top: 6px; }
      #__invoice_root .pay {
        margin-top: 18px; padding: 10px 12px;
        border: 1px dashed #555; border-radius: 6px;
        font-size: 13px; line-height: 1.6;
      }
      #__invoice_root .sign {
        margin-top: 28px; display:flex; justify-content: space-between;
        font-size: 12px;
      }
      #__invoice_root .sign .box { width: 200px; text-align: center; }
      #__invoice_root .sign .ln {
        border-top: 1px solid #333; margin-bottom: 4px; padding-top: 28px;
      }
      #__invoice_root .footer { text-align:center; color:#888; font-size: 10px; margin-top: 20px; }
    </style>

    <h1>${COMPANY.name}</h1>
    <div class="tag">${esc(COMPANY.address1)}</div>
    <div class="tag">${esc(COMPANY.address2)} &nbsp;·&nbsp; Ph: ${esc(COMPANY.phone)}</div>
    <div class="tag" style="margin-top:6px;">
      <b>GSTIN:</b> ${esc(COMPANY.gstin)} &nbsp;&nbsp; <b>FSSAI:</b> ${esc(COMPANY.fssai)}
    </div>
    <div class="tag" style="margin-top:4px; font-style:italic;">${esc(COMPANY.tagline)}</div>

    <div class="rule"></div>
    <div class="titleRow">
      <div>Type: <b>${cashCredit}</b></div>
      <div class="mid">INVOICE</div>
      <div>Invoice #: <b>${esc((order.id || "").slice(0, 8).toUpperCase())}</b></div>
    </div>

    <div class="grid">
      <div class="col" style="flex:1;">
        <b>Bill To:</b><br/>
        <b>${esc(order.store_name)}</b><br/>
        ${store?.address ? esc(store.address) + "<br/>" : ""}
        ${store?.owner ? "Owner: " + esc(store.owner) + "<br/>" : ""}
        ${store?.phone ? "Phone: " + esc(store.phone) : ""}
      </div>
      <div class="col" style="text-align:right;">
        Date: <b>${fmtDate(order.created_at)}</b><br/>
        Pricing: <b>${esc((order.store_type || "retail").toUpperCase())}</b><br/>
        ${order.salesman_name ? "Salesman: <b>" + esc(order.salesman_name) + "</b>" : ""}
      </div>
    </div>

    <table class="items">
      <thead>
        <tr>
          <th style="width:42px;">S.No</th>
          <th>Particulars</th>
          <th style="width:60px;">Qty</th>
          <th style="width:100px;">Rate</th>
          <th style="width:110px;">Amount</th>
        </tr>
      </thead>
      <tbody>${rows}</tbody>
    </table>

    <div class="totalRow">
      <div class="lbl">Grand Total</div>
      <div>Rs. ${fmtINR(order.total)}</div>
    </div>
    <div class="words">In words: ${esc(numToWordsIndian(order.total))}</div>
    ${order.notes ? `<div class="notes">Notes: ${esc(order.notes)}</div>` : ""}

    <div class="pay">
      <b>Payment Details</b><br/>
      GPay / UPI / Phone Pe: <b>${COMPANY.gpay}</b><br/>
      Status: <b>${order.payment_status === "paid" ? "PAID (Cash on Delivery)" : "PENDING / CREDIT"}</b>
    </div>

    <div class="sign">
      <div class="box"><div class="ln"></div>Received by</div>
      <div class="box"><div class="ln"></div>For ${COMPANY.name}<br/>Authorized Signatory</div>
    </div>

    <div class="footer">This is a computer-generated invoice.</div>
  </div>
  `;
}

async function renderInvoiceCanvas(order, store) {
  const wrapper = document.createElement("div");
  wrapper.style.position = "fixed";
  wrapper.style.left = "-10000px";
  wrapper.style.top = "0";
  wrapper.style.zIndex = "-1";
  wrapper.innerHTML = buildInvoiceHtml(order, store);
  document.body.appendChild(wrapper);
  try {
    const node = wrapper.firstElementChild;
    const canvas = await html2canvas(node, {
      scale: 2,
      backgroundColor: "#ffffff",
      useCORS: true,
      logging: false,
    });
    return canvas;
  } finally {
    document.body.removeChild(wrapper);
  }
}

/**
 * Generate invoice PDF and return based on opts.output:
 *   'save' (default) -> triggers download
 *   'blob'           -> { blob, filename }
 *   'bloburl'        -> { url, filename }
 *   'datauristring'  -> { dataUri, filename }
 */
export async function generateInvoicePdf(order, store, opts = {}) {
  const canvas = await renderInvoiceCanvas(order, store);
  const imgData = canvas.toDataURL("image/jpeg", 0.92);

  const pdf = new jsPDF({ unit: "mm", format: "a4" });
  const pageW = pdf.internal.pageSize.getWidth();
  const pageH = pdf.internal.pageSize.getHeight();

  const margin = 8;
  const availW = pageW - margin * 2;
  const imgW = availW;
  const imgH = (canvas.height / canvas.width) * imgW;

  // If single image fits in one page, draw it. Else slice across pages.
  if (imgH <= pageH - margin * 2) {
    pdf.addImage(imgData, "JPEG", margin, margin, imgW, imgH);
  } else {
    // Slice the canvas vertically across multiple pages
    const pxPerMm = canvas.width / imgW;
    const pageContentHmm = pageH - margin * 2;
    const pageContentHpx = pageContentHmm * pxPerMm;
    let y = 0;
    let first = true;
    while (y < canvas.height) {
      const sliceH = Math.min(pageContentHpx, canvas.height - y);
      const slice = document.createElement("canvas");
      slice.width = canvas.width;
      slice.height = sliceH;
      const ctx = slice.getContext("2d");
      ctx.fillStyle = "#ffffff";
      ctx.fillRect(0, 0, slice.width, slice.height);
      ctx.drawImage(
        canvas,
        0, y, canvas.width, sliceH,
        0, 0, canvas.width, sliceH,
      );
      const sliceData = slice.toDataURL("image/jpeg", 0.92);
      const sliceHmm = sliceH / pxPerMm;
      if (!first) pdf.addPage();
      pdf.addImage(sliceData, "JPEG", margin, margin, imgW, sliceHmm);
      first = false;
      y += sliceH;
    }
  }

  const safeName =
    (order.store_name || "invoice").replace(/[^a-z0-9]+/gi, "_").slice(0, 24);
  const filename =
    opts.filename ||
    `${COMPANY.name.replace(/\s+/g, "")}_${safeName}_${(order.id || "").slice(0, 6)}.pdf`;

  const out = opts.output || "save";
  if (out === "save") {
    pdf.save(filename);
    return { filename };
  }
  if (out === "print") {
    // Trigger native print dialog without popup-blocker issues.
    // Strategy: render PDF in a hidden iframe in same window, then call print().
    pdf.autoPrint();
    const url = pdf.output("bloburl").toString();
    const iframe = document.createElement("iframe");
    iframe.style.position = "fixed";
    iframe.style.right = "0";
    iframe.style.bottom = "0";
    iframe.style.width = "0";
    iframe.style.height = "0";
    iframe.style.border = "0";
    iframe.src = url;
    document.body.appendChild(iframe);
    iframe.onload = () => {
      try {
        iframe.contentWindow?.focus();
        iframe.contentWindow?.print();
      } catch (e) {
        // If iframe print fails (e.g. Safari mobile), fall back to download.
        pdf.save(filename);
      }
    };
    // Clean up after a while
    setTimeout(() => {
      try {
        document.body.removeChild(iframe);
        URL.revokeObjectURL(url);
      } catch (e) {
        // ignore
      }
    }, 60_000);
    return { filename, url };
  }
  if (out === "blob") return { blob: pdf.output("blob"), filename };
  if (out === "bloburl") return { url: pdf.output("bloburl").toString(), filename };
  if (out === "datauristring") return { dataUri: pdf.output("datauristring"), filename };
  return { filename };
}

export default generateInvoicePdf;
